import { createClient } from "@supabase/supabase-js";
import type { Database } from "@/integrations/supabase/types";

const FALLBACK_SUPABASE_URL = "https://kfieucudibjgtdvyyoey.supabase.co";
const FALLBACK_SUPABASE_PUBLISHABLE_KEY =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImtmaWV1Y3VkaWJqZ3Rkdnl5b2V5Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjQwMDI2NjcsImV4cCI6MjA3OTU3ODY2N30.RwVSVmBZGFGP8bjVhMs_rOVlIACQ4rCYnfhuuemA2Mk";

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || FALLBACK_SUPABASE_URL;
const supabasePublishableKey =
  import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY || FALLBACK_SUPABASE_PUBLISHABLE_KEY;

if (!import.meta.env.VITE_SUPABASE_URL || !import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY) {
  console.warn("[supabase] Missing Vite env vars in build, using public fallback config.");
}

const authOptions =
  typeof window !== "undefined"
    ? {
        storage: window.localStorage,
        persistSession: true,
        autoRefreshToken: true,
      }
    : {
        persistSession: false,
        autoRefreshToken: false,
      };

export const supabase = createClient<Database>(supabaseUrl, supabasePublishableKey, {
  auth: authOptions,
});